import React, { useState } from 'react';
import InstallmentProgressBar from './InstallmentProgressBar';
import { formatCurrency } from '../../utils/formatCurrency';
import { formatDate } from '../../utils/dateFormatter';

const ITEM_STATUS_STYLES = {
    PAID: 'text-success',
    PARTIAL: 'text-warning',
    PENDING: 'text-muted',
    OVERDUE: 'text-danger',
};

const ITEM_STATUS_ICONS = {
    PAID: 'bi-check-circle',
    PARTIAL: 'bi-pie-chart',
    PENDING: 'bi-clock',
    OVERDUE: 'bi-exclamation-circle',
};

/**
 * Renders payment plan commitment items (compliance tracking, not cash movements).
 */
function PaymentPlanItemsList({
    items = [],
    title = 'Compromisos del plan',
    subtitle,
    collapsible = false,
    defaultExpanded = true,
}) {
    const [expanded, setExpanded] = useState(defaultExpanded);

    if (!items?.length) {
        return null;
    }

    return (
        <div className="payment-plan-items-list">
            <div className="d-flex align-items-center justify-content-between mb-3">
                <div className="flex-grow-1 me-3">
                    <h6 className="mb-1">{title}</h6>
                    {subtitle && <div className="text-muted small">{subtitle}</div>}
                </div>
                {collapsible && (
                    <button
                        type="button"
                        className="btn btn-link text-primary p-0 flex-shrink-0"
                        onClick={() => setExpanded(!expanded)}
                    >
                        {expanded ? (
                            <>
                                <i className="bi bi-chevron-up me-1"></i>
                                Ocultar
                            </>
                        ) : (
                            <>
                                <i className="bi bi-chevron-down me-1"></i>
                                Ver detalle
                            </>
                        )}
                    </button>
                )}
            </div>

            <div className="mb-3">
                <InstallmentProgressBar paymentPlanItems={items} />
            </div>

            {(!collapsible || expanded) && (
                <div className="installments-list mt-2">
                    {items.map((item) => {
                        const statusClass = ITEM_STATUS_STYLES[item.status] || 'text-muted';
                        const statusIcon = ITEM_STATUS_ICONS[item.status] || 'bi-circle';
                        const statusLabel = item.status_label || item.status;

                        return (
                            <div
                                key={item.number}
                                className="d-flex align-items-center p-3 border-bottom"
                            >
                                <div className="me-auto">
                                    <div className="d-flex align-items-center">
                                        <h6 className="mb-0">Cuota {item.number}</h6>
                                        <small className="text-muted ms-2">
                                            <i className="bi bi-calendar3 me-1"></i>
                                            {formatDate(item.due_date)}
                                        </small>
                                    </div>
                                    <small className={statusClass}>
                                        <i className={`bi ${statusIcon} me-1`}></i>
                                        {statusLabel}
                                    </small>
                                </div>
                                <div className="text-end">
                                    <h6 className="mb-0">{formatCurrency(item.amount)}</h6>
                                    {item.status === 'PARTIAL' && item.pending_amount && (
                                        <small className="text-muted d-block">
                                            Pendiente: {formatCurrency(item.pending_amount)}
                                        </small>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}

export default PaymentPlanItemsList;
